/**
 * README:专门计算合同的
 * 销售合同中：
 * 价税合计金额=合同单价*（1+增值税）*合同数量；
 * 增值税初始值从商品带出，可手动修改；修改后，销售合同中的价税合计金额会跟着合同单价、增值税、合同数量进行变动
 *
 * 字段说明
 * 价税合计金额:businessContractTotalAmount
 * 合同单价:businessContractUnitPrice
 * 增值税:taxRate
 * 合同数量:productQuantity
 */
export default {
  methods: {
    // 根据当前行数据计算价税合计金额
    computedBusinessContractTotalAmount(rowData) {
      const result = rowData['businessContractUnitPrice'] * rowData['productQuantity'];
      return result + '' == 'NaN' ? 0 : result.toFixed(6);
    },
    // 根据当前行数据计算  税额的方法
    computedBusinessContractTaxAmount(rowData) {
      const result =
        (Number(rowData['businessContractUnitPrice']) / (1 + +Number(rowData['taxRate']))) *
        Number(rowData['taxRate']) *
        Number(rowData['productQuantity']);
      console.log('合同单价中的税额', result);
      return result + '' == 'NaN' ? 0 : result.toFixed(6);
    },
  },
};
